<form class="card mt-3" [formGroup]="formulario">
    <div class="card-header d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-center flex-column flex-sm-row">

            <h2 class="m-0 mr-2">
                Crear Venta ya!
            </h2>
            <small class="title-description">
                digite todos los datos
            </small>
        </div>
    </div>
    <div class="card-body row">
        <mat-form-field appearance="fill" class="col-6">
            <mat-label>Titulo de la publicación</mat-label>
            <input matInput formControlName="titulo" type="text">
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-6">
            <mat-label>Descripcion (y/o link externo)</mat-label>
            <textarea matInput formControlName="descripcion"></textarea>
        </mat-form-field>
        <mat-form-field appearance="fill" class="col-6">
            <mat-label>Categorias</mat-label>
            <mat-select formControlName="id_categoria">
                <mat-option value="1">Venta consultiva Mach</mat-option>
                <mat-option value="2">NPS</mat-option>
                <mat-option value="3">Enamoramiento crédito</mat-option>
                <mat-option value="4">Campañas</mat-option>
            </mat-select>
        </mat-form-field>
        <!-- <mat-form-field appearance="fill" class="col-6">
            <mat-label>Contenido (Y/o link externo)</mat-label>
            <textarea matInput formControlName="contenido"></textarea>
        </mat-form-field> -->
        <mat-form-field appearance="fill" class="col-6">
            <mat-label>Url Imagen</mat-label>
            <input matInput formControlName="url" type="text">
        </mat-form-field>
    </div>
    <div class="card-footer d-flex align-items-center justify-content-end gap-2">
        <button mat-flat-button type="button" class="btn btn-primary" (click)="create()">Publicar</button>
    </div>
</form>
<div class="shadow mt-3" *ngIf="posts.length>0">
    <coky-table [title]="'Listado de publicaciones'"
        [description]="'Seleccione un registro para habilitar/deshabilitar'" [data]="posts"
        (clickRow)="setState($event)" [multipleSelection]="false">
    </coky-table>
</div>

<div class="card mt-3" *ngIf="posts.length==0">
    <div class="card-body d-flex align-items-center justify-content-between flex-wrap" style="gap: 1rem;">
        <div class="m-1 d-flex align-items-baseline flex-column flex-sm-row">
            <h2 class="m-0 mr-2">
                No hay publicaciones
            </h2>
            <small class="title-description">
                No se ha creado ningúna publicación.
            </small>
        </div>
        <!-- <div class="d-flex align-items-center gap-0">
            <button mat-icon-button (click)="resetForm()" *ngIf="selectedUser!=undefined">
                <mat-icon>add_circle_outline</mat-icon>
            </button>
            <button mat-icon-button (click)="getAllUsers()">
                <mat-icon>refresh</mat-icon>
            </button>
        </div> -->
    </div>
</div>